const MS_PER_DAY = 86_400_000;
const DAYS_PER_WEEK = 7;
const DAYS_TO_THURSDAY = 3;

// ISO-8601 week number: the week containing the Thursday of the given date's week. Mirrors the
// backend's isoWeekNumber so every surface shows the same week label the row was saved under.
export function isoWeekNumber(isoDate: string): number {
  const date = new Date(`${isoDate}T00:00:00Z`);
  const dayOffset = (date.getUTCDay() + DAYS_PER_WEEK - 1) % DAYS_PER_WEEK;
  const thursday = new Date(date.getTime() + (DAYS_TO_THURSDAY - dayOffset) * MS_PER_DAY);
  const yearStart = Date.UTC(thursday.getUTCFullYear(), 0, 1);
  return Math.ceil(((thursday.getTime() - yearStart) / MS_PER_DAY + 1) / DAYS_PER_WEEK);
}
